module.exports = __webpack_public_path__ + "static/img/ffflogo.d425da9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ffflogo.png
// module id = UNMj
// module chunks = 1